<div class="ar-insurance-payment-overpay-confirm" data-cy="ar-insurance-payment-overpay-confirm">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="ar-insurance-payment-overpay-confirm-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="ar-insurance-payment-overpay-confirm-header">
      <div class="section-header-title" data-cy="ar-insurance-payment-overpay-confirm-title">
        Confirm Insurance Overpay
      </div>
    </div>

    <!--  MAIN AREA-->
    <div class="section-content" style="display: flex; flex-direction: column; flex: 1; overflow: hidden; height: 100%;" data-cy="ar-insurance-payment-overpay-confirm-content">
      <app-tdo-progress-spinner style="flex: 1;" *ngIf="isLoading" data-cy="ar-insurance-payment-overpay-confirm-spinner"></app-tdo-progress-spinner>
      <div *ngIf="!isLoading" data-cy="ar-insurance-payment-overpay-confirm-loaded-content">

          <div data-cy="ar-insurance-payment-overpay-confirm-message">The payment has not been fully distributed, and thus the remaining amount of {{ this.currencyPipe.transform(this.overPayAmount, 'USD') }} will be turned into a credit based on the distributions below. Are you sure you want to continue?</div>

          <div style="text-align: right" data-cy="ar-insurance-payment-overpay-confirm-remaining">
            Amount Remaining: {{ this.currencyPipe.transform(this.overPayAmountRemaining, 'USD') }}
          </div>

        <div style="flex: 1; overflow-y: hidden; height: 270px" data-cy="ar-insurance-payment-overpay-confirm-table-container">

          <tdo-table [dataSource]="overPayAmountList"
                     [isMultiSelection]="false" [isSearchable]="false" [isUsePaginator]="false"
                     [isSelectable]="false" data-cy="ar-insurance-payment-overpay-confirm-table">
            <tdo-table-column displayName="Patient" propertyName="PatientName" isSortable="true" [rowTemplate]="desc" data-cy="ar-insurance-payment-overpay-confirm-col-patient">
              <ng-template #desc let-row>
                <div *ngIf="row.model.PatientName" data-cy="ar-insurance-payment-overpay-confirm-patient">{{ row.model.PatientName }}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Claim Number" propertyName="ClaimNumber" isSortable="true" [rowTemplate]="code" data-cy="ar-insurance-payment-overpay-confirm-col-claim">
              <ng-template #code let-row>
                <div *ngIf="row.model.ClaimNumber" data-cy="ar-insurance-payment-overpay-confirm-claim">{{ row.model.ClaimNumber }}</div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Amount" propertyName="Amount" isSortable="true" [rowTemplate]="fee" data-cy="ar-insurance-payment-overpay-confirm-col-amount">
              <ng-template #fee let-row>
                <div style="padding-top:10px" data-cy="ar-insurance-payment-overpay-confirm-amount-container">
                  <mat-form-field floatLabel='never' [style.width.px]=70 data-cy="ar-insurance-payment-overpay-confirm-amount-field">
                    <input matInput appCurrencyFormatter class="input-currency"
                           [value]="row.model.Amount"
                           autocomplete="off"
                           (change)="this.saveAmountEntered($event.target, row.model)" data-cy="ar-insurance-payment-overpay-confirm-amount-input">
                  </mat-form-field>
                </div>

              </ng-template>
            </tdo-table-column>
          </tdo-table>

      </div>
    </div>

    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px;" data-cy="ar-insurance-payment-overpay-confirm-footer">
      <div style="flex: 1; margin-right: 6px;" data-cy="ar-insurance-payment-overpay-confirm-footer-spacer"></div>
      <button (click)="createCreditClick()" [disabled]="overPayAmountRemaining > 0" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="ar-insurance-payment-overpay-confirm-create-btn">Create Credit</button>
      <button (click)="cancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="ar-insurance-payment-overpay-confirm-cancel-btn">Cancel</button>
    </div>
  </div>
</div>


